export class PermissionDataToken {
  static IPermissionDataRepository = Symbol("IPermissionDataRepository");
  static PermissionDataUseCase = Symbol("PermissionDataUseCase");
  static PermissionDataViewModel = Symbol("PermissionDataViewModel");
}
